export default __webpack_public_path__ + "static/rsz_activity_booster-5f9849de2ac30fbcf08433ee01c36b6f.png";